import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, Chip, Stack } from '@mui/material';

import { IcPlus } from '@/assets/images';
import { FormCard, Page, PageHeader } from '@/components';
import { useBuildingInspectionContext } from '@/pages/Tools/BuildingInspection/BuildingInspectionContext';
import { ViolationsDataGrid } from '@/pages/Tools/BuildingInspection/components/ViolationsDataGrid';
import { VisitNotesDataGrid } from '@/pages/Tools/BuildingInspection/components/VisitNotesDataGrid';
import FinishInspectionFailedModal from '@/pages/Tools/BuildingInspection/modals/FinishInspectionFailedModal';
import FinishInspectionPassedModal from '@/pages/Tools/BuildingInspection/modals/FinishInspectionPassedModal';
import ViolationModal from '@/pages/Tools/BuildingInspection/modals/ViolationModal';
import VisitNoteModal from '@/pages/Tools/BuildingInspection/modals/VisitNoteModal';
import { inspectionsStatusColor } from '@/pages/Tools/BuildingInspection/Models';
import { colors } from '@/theme/variables';

const StartInspection = () => {
  const { buildingId, inspectionId } = useParams();
  const [showViolationsDrawer, setShowViolationsDrawer] = useState<
    string | undefined
  >(undefined);
  const [showVisitNoteDrawer, setShowVisitNoteDrawer] = useState<
    string | undefined
  >(undefined);
  const [showFinishInspectionDrawer, setShowFinishInspectionDrawer] = useState<
    string | undefined
  >(undefined);
  const { buildingRecords, inspections, violations } =
    useBuildingInspectionContext();
  const currentBuilding = buildingRecords.find(
    (record) => record._id === buildingId,
  );
  if (!currentBuilding) {
    return <p>Building not found</p>;
  }
  const currentinspection = inspections.find(
    (inspection) => inspection._id === inspectionId,
  );
  if (!currentinspection) {
    return <p>inspection not found</p>;
  }
  if (!currentinspection) {
    return <p>inspection not found</p>;
  }

  return (
    <Page>
      <PageHeader
        title={
          <p>
            {currentinspection?._id}
            <Chip
              sx={{
                backgroundColor:
                  inspectionsStatusColor[currentinspection.status],
                color: '#fff',
                mx: 1,
                fontSize: '12px',
              }}
              label={currentinspection.status}
              size="small"
            />
            <Chip
              sx={{ backgroundColor: colors.grey[10], mx: 1, fontSize: '12px' }}
              label={`${currentBuilding.name}, ${currentBuilding.streetAddress} ${currentBuilding.city} ${currentBuilding.zipCode}`}
              size="small"
            />
          </p>
        }
        backRoute="/tools/building-inspection"
      >
        <Button
          variant="contained"
          color="error"
          size="medium"
          onClick={() => setShowFinishInspectionDrawer('new')}
        >
          Finish inspection
        </Button>
      </PageHeader>

      <FormCard title="Violations" sx={{ flexDirection: 'column' }}>
        <Stack flexDirection="column" ml="16px" sx={{ width: '100%' }}>
          <ViolationsDataGrid></ViolationsDataGrid>
          <Button
            variant="contained"
            color="inherit"
            sx={{
              margin: '20px auto 0 0 ',
              backgroundColor: colors.grey[10],
              color: colors.grey[100],
            }}
            onClick={() => setShowViolationsDrawer('new')}
          >
            <IcPlus style={{ marginRight: '10px' }} />
            Add another record
          </Button>
        </Stack>
      </FormCard>

      <FormCard title="Site visit notes" sx={{ flexDirection: 'column' }}>
        <Stack flexDirection="column" ml="16px" sx={{ width: '100%' }}>
          <VisitNotesDataGrid></VisitNotesDataGrid>
          <Button
            variant="contained"
            color="inherit"
            sx={{
              margin: '20px auto 0 0 ',
              backgroundColor: colors.grey[10],
              color: colors.grey[100],
            }}
            onClick={() => setShowVisitNoteDrawer('new')}
          >
            <IcPlus style={{ marginRight: '10px' }} />
            Add another record
          </Button>
        </Stack>
      </FormCard>

      <ViolationModal
        openModal={showViolationsDrawer}
        setOpenModal={setShowViolationsDrawer}
      />
      <VisitNoteModal
        openModal={showVisitNoteDrawer}
        setOpenModal={setShowVisitNoteDrawer}
      />

      {violations.find(
        (violation) =>
          violation.inspection_id === inspectionId && !violation.isCorrected,
      ) ? (
        <FinishInspectionFailedModal
          openModal={showFinishInspectionDrawer}
          setOpenModal={setShowFinishInspectionDrawer}
        />
      ) : (
        <FinishInspectionPassedModal
          openModal={showFinishInspectionDrawer}
          setOpenModal={setShowFinishInspectionDrawer}
        />
      )}
    </Page>
  );
};

export default StartInspection;
